<template>
    <div>
        <v-parallax src="@/assets/verde.jpg">
            <div class="text--primary pa-5"><br>
                <v-sheet
                    class="d-flex align-center justify-center flex-wrap text-center mx-auto as-box-title as-bg-color-100"
                    height="150" rounded max-width="600" width="100%" mb="12">
                    <div>
                        <div class="text-h5 font-weight-medium pa-2">
                            DIRECCIÓN GENERAL LOGÍSTICA<br />UNIDAD DE MATERIAL BÉLICO
                        </div>
                        <p class="text-body-2 mb-4">
                            Registro clasificado de armas de fuego, municiones y explosivos de uso
                            Militar <br />
                            -- REPOSICION CUCHILLO BAYONETA --
                        </p>
                    </div>
                </v-sheet>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-hover v-slot="{ isHovering, props }">
                            <router-link to="/resarcimientoejercito">
                                <v-card v-bind="props" :elevation="isHovering ? 24 : 6" class="mx-auto pa-6">
                                    <v-img src="@/assets/ejto.png" alt="Imagen" class="img"></v-img>
                                </v-card>
                            </router-link>
                        </v-hover>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-hover v-slot="{ isHovering, props }">
                            <router-link to="/reposicioncuchilloaerea">
                                <v-card v-bind="props" :elevation="isHovering ? 24 : 6" class="mx-auto pa-6">
                                    <v-img src="@/assets/aerea.png" alt="Imagen" class="img"></v-img>
                                </v-card>
                            </router-link>
                        </v-hover>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-hover v-slot="{ isHovering, props }">
                            <router-link to="/reposicioncuchilloarmada">
                                <v-card v-bind="props" :elevation="isHovering ? 24 : 6" class="mx-auto pa-6">
                                    <v-img src="@/assets/ab.png" alt="Imagen" class="img"></v-img>
                                </v-card>
                            </router-link>
                        </v-hover>
                    </v-col>
                </v-row>
            </div>
        </v-parallax>
    </div>
</template>

<script>

</script>
